/**
 * Resample filter interface.
 *
 * @see https://www.imagemagick.org/Usage/filter/#filter Resampling Filters at ImageMagick docs
 */
export interface ResampleFilter {
  /**
   * Returns filter practical working support.
   */
  getWorkingSupport(): number;

  /**
   * Returns color weight at given distance from EWA ellipse center.
   *
   * @param x
   */
  getWeight(x: number): number;
}

/**
 * Checks if passed object implements ResampleFilter interface.
 *
 * @param candidate
 */
export function isResampleFilter(
  candidate: unknown
): candidate is ResampleFilter {
  type C = Partial<ResampleFilter>;
  return (
    typeof candidate === "object" &&
    candidate !== null &&
    typeof (candidate as C).getWorkingSupport === "function" &&
    typeof (candidate as C).getWeight === "function"
  );
}
